module.exports = __webpack_public_path__ + "static/img/tn_1.111d780.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/tn_1.png
// module id = 968
// module chunks = 1